import { render, staticRenderFns } from "./CreateFixedAssetEdited.vue?vue&type=template&id=32df0a24"
import script from "./CreateFixedAssetEdited.vue?vue&type=script&lang=js"
export * from "./CreateFixedAssetEdited.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports